import { Button, Container } from "react-bootstrap";
import { PageWrap } from "./PageWrap";
import { paths } from "../types/Defaults";

export const NoMatch = () => {
  return (
    <PageWrap>
      <Container>
        <div className="w-full d-flex flex-column align-items-center justify-content-center text-center py-5">
          <h1 className="fw-bold mb-2" style={{ fontSize: "3rem" }}>
            404
          </h1>
          <h3 className="mb-3">Page not found</h3>
          <p className="text-muted mb-4" style={{ maxWidth: "40rem" }}>
            Sorry, this page is unavailable. Please return to our homepage to
            continue browsing.
          </p>
          <Button href={paths.externalHome} className="btn btn-primary px-4">
            Back to Home
          </Button>
        </div>
      </Container>
    </PageWrap>
  );
};
